module.exports = __webpack_public_path__ + "img/2-1.e094eb24.jpg";